var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"grow":""}},[_c('v-tab',{key:"1"},[_vm._v("Calendar")]),_c('v-tab',{key:"2"},[_vm._v("Event Log")]),_c('v-tab-item',[_c('v-container',[_c('RoomCalenderVue')],1)],1),_c('v-tab-item',[_c('v-container',[_c('EventLogVue')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }